import React, {Component} from 'react';
// import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple, FuseAnimate} from '@fuse';
import { Chip, Grid, Button, Typography, SwipeableDrawer, LinearProgress, Avatar, Badge, Paper, Snackbar, IconButton } from '@material-ui/core';
// import Pagination from "material-ui-flat-pagination";
// import Fab from '@material-ui/core/Fab';
// import _ from 'lodash';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

import HomeIcon from '@material-ui/icons/Home';
import EditIcon from '@material-ui/icons/Edit';
import WarningIcon from '@material-ui/icons/Warning';
import ListIcon from '@material-ui/icons/List';
// import DeleteIcon from '@material-ui/icons/Delete';
// import AddIcon from '@material-ui/icons/Add';
// import CompareIcon from '@material-ui/icons/CompareArrows';
// import ListAltSharpIcon from '@material-ui/icons/List';
// import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
// import { deepPurple } from '@material-ui/core/colors';

// function TabContainer(props) {
//     return (
//       <Typography component="div" style={{ padding: 8 * 3 }}>
//         {props.children}
//       </Typography>
//     );
// }

// TabContainer.propTypes = {
//     children: PropTypes.node.isRequired,
// };

const styles = theme => ({
    layoutRoot: {},
    paperWarningSave : {
        borderRadius: 0,
        padding: 5,
        background: '#FFEB3B',
        color: 'black',
        textAlign: 'center',
        fontSize: '11px',
        position: 'absolute',
        width: '100%',
        zIndex: '999999',
        top: '105px',
        boxShadow: '0px 0px'
    },
    linearColorPrimary: {
        backgroundColor: '#FFECB3',
    },
    linearBarColorPrimary: {
        backgroundColor: '#FFC108',
    },
    linearColorPrimary100: {
        backgroundColor: '#C8E6C9',
    },
    linearBarColorPrimary100: {
        backgroundColor: '#558B2F',
    },
    colorWhite: {
        color: 'white'
    },
    colorDark : {
        color: '#434343'
    },
    persentaseTotal: {
        padding: 0,
        background: '#0097A7',
        textAlign: 'center',
        color: 'white'
    },
    persenTotalText: {
        fontSize: '35px',
        color: '#F0F4C3',
        fontWeight: 'bold'
    }
});

class InstrumenAll extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            namaPengguna: 'Khalid',
            bottom: false,
            ListMenu: null,
            email: null,
            tabValue: 0,
            activeStep: 1,
            routeParams: {
                token: null,
                start: 0,
                limit: 20,
                pengguna_id: null,
                load_children: 0,
                tingkat_instrumen: 2,
                tahun_ajaran_id: localStorage.getItem('tahun'),
                kode: null,
                tahun: localStorage.getItem('tahun')
            },
            persenRata: 0
        };
    }

    simpanKuesioner = () => {

        this.setState({
            ...this.state,
            routeParams: {
                ...this.state.routeParams,
                kuesioner: this.props.kuesioner
            }
        }, () => {
            this.props.simpanKuesioner(this.state.routeParams).then((result)=>{
                this.props.setKuesionerDirty(0);
                this.handleSnackbarOpen();
                // this.handleClickDialogOpen('Jawaban Berhasil Disimpan', 'Kembali ke kategori sebelumnya');
            });
        })

    }

    handleSnackbarOpen = () => {
        this.setState({ SnackbarOpen: true });
    }

    handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        this.setState({ SnackbarOpen: false });
    };

    getStepContent = (step) => {
        switch (step) {
            case 0:
              return `For each ad campaign that you create, you can control how much
                      you're willing to spend on clicks and conversions, which networks
                      and geographical locations you want your ads to show on, and more.`;
            case 1:
              return 'An ad group contains one or more ads which target a shared set of keywords.';
            case 2:
              return `Try out different ad text to see what brings in the most customers,
                      and learn how to enhance your ads using features like ad extensions.
                      If you run into any problems with your ads, find out how to tell if
                      they're running and how to resolve approval issues.`;
            default:
              return 'Unknown step';
        }
    }

    goTolink = (url) => {
        this.props.history.push(url);
    };

    getJenjangResponden = (sekolah, pengguna) => {
        let arrReturn = {};

        if(Number(pengguna.peran_id) === 10){
            arrReturn.responden = 'kepsek';
        }else if(Number(pengguna.peran_id) === 12 || Number(pengguna.peran_id) === 90){
            arrReturn.responden = 'siswa';
        }else if(Number(pengguna.peran_id) === 13){
            arrReturn.responden = 'pengawas';
        }else if(Number(pengguna.peran_id) === 14){
            arrReturn.responden = 'komite';
        }else if(Number(pengguna.peran_id) === 53){
            arrReturn.responden = 'guru';
        }
        
        // if(Number(sekolah.bentuk_pendidikan_id) === 5){
        //     arrReturn.jenjang = 'SD';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 6){
        //     arrReturn.jenjang = 'SMP';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 13){
        //     arrReturn.jenjang = 'SMA';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 15){
        //     arrReturn.jenjang = 'SMK';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 29){
        //     arrReturn.jenjang = 'SLB';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 7){
        //     arrReturn.jenjang = 'SLB';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 8){
        //     arrReturn.jenjang = 'SLB';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 14){
        //     arrReturn.jenjang = 'SLB';
        // }

        if(Number(sekolah.bentuk_pendidikan_id) === 5){
            arrReturn.jenjang = 'SD';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 53){
            arrReturn.jenjang = 'SD';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 6){
            arrReturn.jenjang = 'SMP';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 54){
            arrReturn.jenjang = 'SMP';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 13){
            arrReturn.jenjang = 'SMA';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 55){
            arrReturn.jenjang = 'SMA';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 15){
            arrReturn.jenjang = 'SMK';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 29){
            arrReturn.jenjang = 'SLB';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 7){
            arrReturn.jenjang = 'SLB';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 8){
            arrReturn.jenjang = 'SLB';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 14){
            arrReturn.jenjang = 'SLB';
        }

        return arrReturn;
    }

    componentDidMount = () => {
        
        this.props.setLoadingBesar(true);
        this.props.setJudul('Perangkat Kuesioner');

        this.setState({
            ...this.state,
            namaPengguna: JSON.parse(localStorage.getItem('user')).nama,
            email: JSON.parse(localStorage.getItem('user')).email,
            routeParams: {
                ...this.state.routeParams,
                load_children: 1,
                tingkat_instrumen: 1,
                pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
                sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
                tahun_ajaran_id: localStorage.getItem('tahun'),
                jenjang: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).jenjang,
                responden: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).responden,
                instrumen_id: localStorage.getItem('instrumen_id'),
                media_id: 1,
                kelompok_kode: '["A", "B", "C", "D", "E", "F", "G", "H"]'

            }
        },()=>{
            // this.props.InstrumenAll(this.state.routeParams).then((result)=>{
            //     this.props.setLoadingBesar(false);
            // });

            this.props.getSekolah(this.state.routeParams).then((option)=>{

                this.setState({
                    routeParams: {
                        ...this.state.routeParams,
                        jenjang: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).jenjang,
                        responden: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).responden
                    }
                },()=>{

                    this.props.getRekapKemajuan(this.state.routeParams).then((result)=>{
                        // alert('tes');
                        
                        let persenTotal = 0;
                        let rowTotal = 0;

                        for (let index = 0; index < this.props.rekap_kemajuan.rows.length; index++) {
                            const element = this.props.rekap_kemajuan.rows[index];  
                            
                            // persenTotal = persenTotal+Number(element.persentase);
                            if(element.jumlah_total > 0){
                                persenTotal = persenTotal+Number(element.persentase);
                                rowTotal++;
                            }
            
                        }
        
                        let persenRata = (persenTotal/rowTotal).toFixed(1);
        
                        this.setState({
                            ...this.state,
                            persenRata: persenRata
                        });

                        this.props.setLoadingBesar(false);
                    })
                });
            });
        });

        // this.props.InstrumenAll(this.state.routeParams);

    }

    bukaMenuUtama = () => {
        this.setState({ 
            ...this.state, 
            bottom: true
        });
    }

    toggleDrawer = (side, open, option) => () => {
        this.setState({ ...this.state, [side]: open });
    }

    handleChangeTab = (event, value) => {
        this.setState({ tabValue: value });
    };

    hitungRekapKemajuan = () => {
        this.props.setLoadingBesar(true);
        // alert('tes');
        this.setState({
            routeParams: {
                ...this.state.routeParams,
                load_children: 1,
                tingkat_instrumen: 1,
                pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
                sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
                tahun_ajaran_id: localStorage.getItem('tahun'),
                jenjang: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).jenjang,
                responden: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).responden,
                instrumen_id: localStorage.getItem('instrumen_id'),
                media_id: 1,
                kelompok_kode: '["A", "B", "C", "D", "E", "F", "G", "H"]'

            }
        },()=>{
            this.props.hitungRekapKemajuan(this.state.routeParams).then((result)=>{
                // this.props.setLoadingBesar(false);
                let persenTotal = 0;
                let rowTotal = 0;

                for (let index = 0; index < this.props.rekap_kemajuan.rows.length; index++) {
                    const element = this.props.rekap_kemajuan.rows[index];  
                    
                    // persenTotal = persenTotal+Number(element.persentase);
                    if(element.jumlah_total > 0){
                        persenTotal = persenTotal+Number(element.persentase);
                        rowTotal++;
                    }
    
                }

                let persenRata = (persenTotal/rowTotal).toFixed(1);

                this.setState({
                    ...this.state,
                    persenRata: persenRata
                });

                this.props.setLoadingBesar(false);
            });
        });
    }

    render()
    {
        const {classes} = this.props;
        const {bottom, ListMenu} = this.state;

        return (
            <FusePageSimple
                style={{overflow: 'auto'}}
                classes={{
                    root: classes.layoutRoot
                }}
                content={
                    <FuseAnimate
                        animation="transition.slideRightBigIn"
                        duration={400}
                        delay={400}
                    >
                    <div style={{width: '100%'}} className="konten-utama">
                    
                        <div className="p-16" style={{border: '0px solid #ccc', width: '100%', background: 'url(http://'+window.location.host+'/assets/images/backgrounds/library.jpg)', marginTop: '-1px', backgroundPosition: 'center', backgroundSize: 'cover', minHeight: 130}}>
                            <Grid container spacing={16} style={{background: 'rgb(0,0,0,0.4)', borderRadius: '4px'}}>
                                <Grid item xs={12} sm={8} style={{paddingLeft: 20}}>
                                    <h1 style={{fontSize: 20, fontFamily: 'Helvetica', color: 'white'}}>Perangkat Kuesioner</h1>
                                    <h4 style={{fontSize: 15, color: 'white'}}>Pemetaan Penjaminan Mutu Pendidikan</h4>
                                </Grid>
                                <Grid item xs={12} sm={4} style={{textAlign: 'right'}}>
                                    <Paper className={classes.persentaseTotal}>
                                        <Typography className={classes.colorWhite}>Progres Pengisian Anda</Typography>
                                        <Typography className={classes.persenTotalText}>{this.state.persenRata}%</Typography>
                                    </Paper>
                                    {/* <Badge className={classes.margin} badgeContent={4} color="primary"> */}
                                    <Badge badgeContent={<WarningIcon style={{color: 'yellow'}}/>} className={classes.margin} style={{width:'100%'}}>
                                        <Button variant="raised" color="secondary" style={{width:'100%', marginTop: '8px'}}
                                            onClick={this.hitungRekapKemajuan}
                                            >
                                            Hitung Rekap Kemajuan Anda
                                        </Button>
                                    </Badge>
                                </Grid>
                            </Grid>
                        </div>

                        <div style={{minHeight: 10, width: '100%', background: '#4EBBE8', overflow: 'auto', maxHeight: '42px', display: 'inline-flex'}}>
                            <Chip
                                icon={<HomeIcon/>}
                                label=""
                                className={this.props.classes.chip}
                                color="primary"
                                style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                onClick={()=>{this.goTolink('/Beranda')}}
                                />
                            <Chip
                                label={"> Isi Kuesioner"}
                                className={this.props.classes.chip}
                                color="secondary"
                                style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                            />
                        </div>

                        {this.props.dirty === 1 &&
                        <Paper className={classes.paperWarningSave}>
                            <WarningIcon style={{fontSize: '12px'}}/> Terdapat jawaban yang belum tersimpan. Segera klik tombol simpan untuk menghindari hilangnya jawaban Anda!
                        </Paper>
                        }
                        <div className="p-16">
                            
                            {
                            this.props.rekap_kemajuan.rows
                            .filter(option => option.jumlah_total > 0)
                            .map((option)=>{
                                
                                let classus = {};
                                let classColor = '';
                                let bgColor = '';

                                // if(option.jumlah_total > 0){

                                    if(option.persentase === "100"){
                                        classus = {
                                            colorPrimary: classes.linearColorPrimary100,
                                            barColorPrimary: classes.linearBarColorPrimary100,
                                        };
                                        classColor = 'white';
                                        bgColor = '#558B2F';
                                    }else{
                                        classus = {
                                            colorPrimary: classes.linearColorPrimary,
                                            barColorPrimary: classes.linearBarColorPrimary,
                                        };
                                        classColor = '#434343';
                                        bgColor = '#FFC107';
                                    }

                                    return (
                                        <Grid container spacing={16} key={option.instrumen_id}>
                                            <Grid item xs={12} sm={12} style={{minHeight: 0}}>
                                                {/* <Avatar style={{margin: 10, color: '#000', backgroundColor: '#D1E751'}}>A</Avatar> */}
                                            </Grid>
                                            <Grid item xs={2} sm={1} style={{border: '0px solid #ccc', padding: '0px'}}>
                                                <Avatar style={{marginLeft: 17, color: classColor, backgroundColor: bgColor}}>{option.kode}</Avatar>
                                                <div style={{borderLeft: '3px solid #ccc', width: '10px', height: '120px', marginLeft: 35, marginTop: '0px'}}></div>
                                            </Grid>
                                            <Grid item xs={10} sm={11} style={{borderBottom: '1px solid #ccc', minHeight: '100px'}}>
                                                <Typography style={{marginTop: '0px', fontSize: 20}}>{option.kode}. {option.judul}</Typography>
                                                <LinearProgress 
                                                    variant="determinate" 
                                                    value={Math.ceil(option.persentase)} 
                                                    style={{height: '30px'}}
                                                    classes={classus}
                                                />
                                                <Typography style={{position: 'absolute', marginTop: '-25px', color: classColor, marginLeft: '10px'}}>Progres pengisian: <b>{Math.ceil(option.persentase)}%</b> ({option.jumlah_terjawab} dari {option.jumlah_total})</Typography>
                                                <Typography variant="caption" style={{fontStyle: 'italic'}}>Tanggal Rekap Terakhir: {option.tanggal_rekap_terakhir && option.tanggal_rekap_terakhir.substring(0,16)}</Typography>
                                                {/* <Button variant="extendedFab" style={{minWidth: '50px', padding: 10, background: '#FFC107', position: 'absolute', marginTop: '-40px', marginLeft: (Math.ceil(option.persentase)-10)+'%' }}><FaceIcon/></Button> */}
                                                <br/>
                                                <Button variant="contained" size="small" style={{marginRight: 5}} onClick={()=>{this.props.history.push('/RincianKemajuan/'+option.kode)}}><ListIcon/> &nbsp;&nbsp; Rincian</Button>
                                                {this.props.konfirmasi_instrumen_id !== null &&
                                                    <Button variant="contained" color="primary" size="small" onClick={()=>{this.props.history.push('/LembarInstrumen/'+option.kode)}} disabled={true}><EditIcon/> &nbsp;&nbsp; Lanjutkan </Button>
                                                }
                                                {this.props.konfirmasi_instrumen_id === null &&
                                                    <Button variant="contained" size="small" onClick={()=>{this.props.history.push('/LembarInstrumen/'+option.kode)}}><EditIcon/> &nbsp;&nbsp; Lanjutkan </Button>
                                                }
                                            </Grid>
                                        </Grid>
                                    )
                                // }
                            })}
                        </div>
                        
                        <SwipeableDrawer
                            anchor="bottom"
                            open={bottom}
                            onClose={this.toggleDrawer('bottom', false, null)}
                            onOpen={this.toggleDrawer('bottom', true, null)}
                        >
                            <div style={{padding: 0, minHeight: 100, maxHeight: 400, overflow: 'auto'}}>
                                {ListMenu}
                            </div>
                        </SwipeableDrawer>
                        <Snackbar
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            open={this.state.SnackbarOpen}
                            autoHideDuration={6000}
                            onClose={this.handleSnackbarClose}
                            ContentProps={{
                                'aria-describedby': 'message-id',
                            }}
                            message={<span id="message-id">Jawaban berhasil disimpan!</span>}
                            action={[
                                <IconButton
                                  key="close"
                                  aria-label="Close"
                                  color="inherit"
                                  className={classes.close}
                                  onClick={this.handleSnackbarClose}
                                >
                                  <CloseIcon />
                                </IconButton>,
                            ]}
                        />
                    </div>
                    </FuseAnimate>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setKuesioner: Actions.setKuesioner,
        getKuesioner: Actions.getKuesioner,
        setKuesionerDirty: Actions.setKuesionerDirty,
        setRadioKuesioner: Actions.setRadioKuesioner,
        simpanKuesioner: Actions.simpanKuesioner,
        getRekapKemajuan: Actions.getRekapKemajuan,
        hitungRekapKemajuan: Actions.hitungRekapKemajuan,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getSekolah: Actions.getSekolah,
        setJudul: Actions.setJudul,
        setLoadingBesar: Actions.setLoadingBesar,
        InstrumenAll: Actions.InstrumenAll
    }, dispatch);
}

function mapStateToProps({ Instrumen, Sekolah, App }) {

    return {
        kuesioner: Instrumen.kuesioner,
        fetch_kuesioner: Instrumen.fetch_kuesioner,
        hasil_simpan: Instrumen.hasil_simpan,
        dirty: Instrumen.dirty,
        radioCheck: Instrumen.radioCheck,
        rekap_kemajuan: Instrumen.rekap_kemajuan,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        sekolah: Sekolah.sekolah,
        loading_besar: App.loading_besar,
        instrumen_all: Instrumen.instrumen_all
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(InstrumenAll)));



// WEBPACK FOOTER //
// ./src/main/content/Instrumen/InstrumenAll.js